import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { AgentProfileDto, AgentSpecialtiesUpdateDto, AgentSpecialty } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentSpecialtiesDisplayComponent } from '../display/agent-specialties-display.component';
import { AgentSpecialtiesFormComponent } from '../form/agent-specialties-form.component';

@Component({
  selector: 'etxe-agent-specialties-edit',
  imports: [AuraEditWrapperComponent, AgentSpecialtiesFormComponent, AgentSpecialtiesDisplayComponent],
  templateUrl: './agent-specialties-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentSpecialtiesEditComponent {
  readonly initialProfile = input<AgentProfileDto | null>(null);
  readonly initialSpecialties = input<(AgentSpecialty | string)[] | undefined>(undefined);
  readonly isEditing = model<boolean>(false);
  readonly isAllowedToEdit = input<boolean>(true);

  readonly saved = output<AgentSpecialtiesUpdateDto>();
  readonly profileSaved = output<AgentProfileDto>();

  readonly currentSpecialties = computed(() => {
    return this.initialSpecialties() ?? this.initialProfile()?.activity?.specialties ?? [];
  });

  onSave(dto: AgentSpecialtiesUpdateDto | null): void {
    if (!dto) return;
    this.saved.emit(dto);
    const profile = this.initialProfile();
    if (profile) {
      this.profileSaved.emit({
        ...profile,
        activity: {
          ...profile.activity,
          specialties: dto.specialties,
        },
      });
    }
  }
}
